/**
 * This file has been created for SEO purposes. To prevent google bot from finding the search filters and create crawl traps
 * a href have been removed from the search filters. This script hooks into the search filters and takes the user to the correct url
 * the filter would have taken the user.
 *
 */

export default (url, evt) => {
    if (url !== '') {
        if (evt.ctrlKey) {
            window.open(url);
        } else {
            window.location.href = url;
        }
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/open-javascript-href.js